// ============================================================
//  Importschicht (Umsetzung §7.1). Zwei Quellen: Upload (aktiv) und
//  Connector (Stub, available:false). System- und Mandantenkennung sind
//  Pflicht (I15) — sonst Ablehnung mit klarer Meldung.
// ============================================================

export interface RawRow {
  [column: string]: string;
}

export interface RawTables {
  [tableName: string]: RawRow[];
}

export interface ImportSpec {
  files?: File[];
  mapping?: Record<string, string>;
}

export interface ImportSource {
  id: string;
  label: string;
  available: boolean;
  load(spec: ImportSpec): Promise<RawTables>;
}

export interface RowValidation {
  ok: boolean;
  reason?: string;
}

/** I15: Jeder Importdatensatz trägt System UND Mandant, sonst Ablehnung. */
export function validateImportRow(
  row: RawRow,
  systemColumn = "SID",
  clientColumn = "MANDT",
): RowValidation {
  const sid = (row[systemColumn] ?? "").trim();
  const client = (row[clientColumn] ?? "").trim();
  if (!sid) return { ok: false, reason: `Systemkennung (${systemColumn}) fehlt` };
  if (!client) return { ok: false, reason: `Mandantenkennung (${clientColumn}) fehlt` };
  return { ok: true };
}

/** Connector-Stub — in der Oberfläche sichtbar als „geplant". */
export const ConnectorSource: ImportSource = {
  id: "connector",
  label: "Automatischer Abruf — geplant",
  available: false,
  async load() {
    throw new Error("Automatischer Abruf ist noch nicht angebunden.");
  },
};
